export default __webpack_public_path__ + "media/images/73-889e6d82a914b9847c8e7faa2b91e401.jpg";